"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VERSION_NEUTRAL = void 0;
/**
 * Indicates that this will work for any version passed in the request, or no version.
 *
 * @publicApi
 */
exports.VERSION_NEUTRAL = Symbol('VERSION_NEUTRAL');
